module.exports = __webpack_public_path__ + "img/banner-ga.0d2dedf0.png";